import { useEffect, useState } from 'react';

const useScriptLoader = (url) => {

    const [scriptNode, setScriptNode] = useState(null);

    const loader = (callback) => {
        const script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.onload = callback;
        document.body.appendChild(script);
        setScriptNode(script);
    }

    useEffect(() => {
        return () => {
            scriptNode && document.body.removeChild(scriptNode);
        }
    }, [])

    return loader;
}

export default useScriptLoader;